export default __webpack_public_path__ + "static/media/Example3.1b5e0f70.jpeg";